/*!
 * Shipping Progress Bar — SIMPLE v2.14
 * - FREE=70, GIFT=100 (lokale valuta)
 * - Subregel pas ná FREE
 * - Taal altijd Engels
 * - Valuta op basis van store/market currency (Shopify/cart), fallback USD
 * - Pins IN de balk (36px desktop / 30px mobile), bar 8px, groen #22C55E
 * - FIX: 🚚-pin staat op echte drempel (FREE/GIFT) en vulling houdt 2% speling bij pins
 */

(function(){
  var FREE = 70, GIFT = 100;

  // --- Taal altijd Engels ---
  var LOCALE = 'en-US';
  var CURRENCY = 'USD';

  function getCurrencyFromShopify(){
    try{
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        return String(Shopify.currency.active).toUpperCase();
      }
    }catch(e){}
    return null;
  }

  function localeFromCurrency(currency){
    // Houd tekst Engels, kies alleen een handige locale voor formatting
    if (currency === 'USD') return 'en-US';
    if (currency === 'GBP') return 'en-GB';
    if (currency === 'EUR') return 'en-IE';
    if (currency === 'CAD') return 'en-CA';
    if (currency === 'AUD') return 'en-AU';
    return 'en-US';
  }

  function rebuildFormatter(){
    LOCALE = localeFromCurrency(CURRENCY || 'USD');
    return new Intl.NumberFormat(LOCALE, {
      style:'currency',
      currency:(CURRENCY || 'USD'),
      minimumFractionDigits:2
    });
  }

  var fmt = rebuildFormatter();

  // Copy (EN only)
  var T = {
    head_under:  function(a){ return `Only ${a} away from free shipping`; },
    head_free:   function(){ return `You’ve got free shipping`; },
    sub_gift:    function(a){ return `Only ${a} away from your free gift`; },
    head_both:   function(){ return `You get free shipping and a gift 🎉`; }
  };

  // --- CSS (met variabele plaatsing van FREE-pin) ---
  (function injectCSS(){
    if (document.getElementById('spb-simple-styles-v214')) return;
    var css = `
      .drawer__fixed-header{ overflow: visible; }

      .spb{
        --spb-bar-h: 8px;
        --spb-pin-s: 36px;
        --spb-pin-r: 18px;
        font-family:inherit; color:#fff; margin:6px 0 8px;
      }
      .spb[hidden]{display:none!important}

      .spb__textwrap{ margin:0 0 calc((var(--spb-pin-s) - var(--spb-bar-h))/2 + 6px); }
      .spb__head{
        font-size:.82rem; line-height:1.2; font-weight:700; margin:0 0 2px;
        display:-webkit-box; -webkit-line-clamp:1; -webkit-box-orient:vertical; overflow:hidden; text-overflow:ellipsis;
      }
      .spb__sub{
        font-size:.75rem; line-height:1.2; opacity:.9; margin:0;
        display:-webkit-box; -webkit-line-clamp:1; -webkit-box-orient:vertical; overflow:hidden; text-overflow:ellipsis;
      }

      .spb__bar{position:relative;height:var(--spb-bar-h);background:rgba(255,255,255,.2);
                border-radius:999px;overflow:visible}
      .spb__fill{position:absolute;left:0;top:0;height:100%;width:0;background:#E2A607;
                 border-radius:inherit;transition:width .2s ease,background-color .2s ease}
      .spb.is-free .spb__fill{background:#22C55E}

      .spb__pin{
        position:absolute; top:50%; transform:translate(-50%,-50%);
        width:var(--spb-pin-s); height:var(--spb-pin-s); border-radius:999px;
        display:grid; place-items:center; background:#111; border:2px solid #333;
        box-shadow:0 6px 18px rgba(0,0,0,.25);
        font-size:calc(var(--spb-pin-s) * .52); line-height:1; z-index:1; pointer-events:none;
      }
      /* FREE-pin staat op echte drempel: via --spb-free-pct die we inline zetten */
      .spb__pin--free{ left:var(--spb-free-pct, 50%); }
      .spb__pin--gift{ left:calc(100% - var(--spb-pin-r)); }
      .spb.is-free .spb__pin--free{ border-color:#E2A607 }
      .spb.is-gift .spb__pin--gift{ border-color:#E2A607 }

      @media (max-width:420px){
        .spb{ --spb-pin-s:30px; --spb-pin-r:15px; }
        .spb__head{font-size:.8rem}
        .spb__sub{font-size:.72rem}
      }
    `.trim();
    var style=document.createElement('style');
    style.id='spb-simple-styles-v214';
    style.textContent=css;
    document.head.appendChild(style);
  })();

  // zelfde zij-gutters als body (ook in header)
  function applyGutter(container){
    try{
      var drawer = document.getElementById('CartDrawer');
      var scroll = drawer && drawer.querySelector('.drawer__inner .drawer__scrollable');
      var gutter = 16;
      if (scroll){
        var cs = getComputedStyle(scroll);
        var pl = parseFloat(cs.paddingLeft)||0, pr = parseFloat(cs.paddingRight)||0;
        gutter = Math.max(pl, pr, 16);
      }else{
        var row = drawer && drawer.querySelector('.cart__item-row');
        if (row){
          var cs2 = getComputedStyle(row);
          gutter = Math.max(parseFloat(cs2.paddingLeft)||0, parseFloat(cs2.paddingRight)||0, 16);
        }
      }
      container.style.paddingLeft = gutter+'px';
      container.style.paddingRight = gutter+'px';
    }catch(e){}
  }

  function mountEl(){
    var el = document.getElementById('ShippingProgressMount');
    if (!el) return null;
    if (!/\bcart__item-row\b/.test(el.className)) el.classList.add('cart__item-row');
    applyGutter(el);
    return el;
  }

  function render(total){
    var mount = mountEl(); if (!mount) return;
    if (total <= 0){ mount.style.display='none'; return; }
    mount.style.display='';

    var free = FREE, gift = Math.max(GIFT, FREE);
    var isFree = total >= free;
    var isGift = total >= gift;

    // Teksten (stap-voor-stap)
    var headHTML = '', subHTML = '';
    if (isGift){
      headHTML = T.head_both(); subHTML = '';
    } else if (isFree){
      headHTML = T.head_free(); subHTML = T.sub_gift(fmt.format(gift - total));
    } else {
      headHTML = T.head_under(fmt.format(free - total)); subHTML = '';
    }

    // Plaats FREE-pin op echte drempelpositie
    var freePct = (free / gift) * 100;

    // Vulling: echte schaal naar gift, maar met mini-speling bij pins
    var pctTrue = Math.min(total, gift) / gift * 100;
    var gap = 2; // % visuele speling t.o.v. pin
    var pct = pctTrue;
    if (total < free) {
      pct = Math.min(pctTrue, freePct - gap);          // net vóór de 🚚-pin
    } else if (total < gift) {
      pct = Math.min(pctTrue, 100 - gap);              // net vóór de 🎁-pin
    } // bij gift of meer: laat 100%

    mount.innerHTML = `
      <section class="spb ${isFree?'is-free':''} ${isGift?'is-gift':''}" style="--spb-free-pct:${freePct}%">
        <div class="spb__textwrap">
          <p class="spb__head">${headHTML}</p>
          ${subHTML ? `<p class="spb__sub">${subHTML}</p>` : ``}
        </div>

        <div class="spb__bar" role="progressbar" aria-valuemin="0" aria-valuemax="${gift}" aria-valuenow="${Math.min(total,gift)}">
          <div class="spb__fill" style="width:${pct}%"></div>
          <div class="spb__pin spb__pin--free" aria-hidden="true">🚚</div>
          <div class="spb__pin spb__pin--gift" aria-hidden="true">🎁</div>
        </div>
      </section>`;
  }

  function refresh(){
    fetch('/cart.js',{credentials:'same-origin'})
      .then(function(r){return r.json();})
      .then(function(c){
        // Valuta op basis van store/market currency:
        // 1) Shopify.currency.active
        // 2) cart.currency
        // 3) fallback USD
        var detectedCurrency =
          getCurrencyFromShopify() ||
          (c && c.currency ? String(c.currency).toUpperCase() : null) ||
          'USD';

        if (detectedCurrency !== CURRENCY){
          CURRENCY = detectedCurrency;
          fmt = rebuildFormatter();
        }

        // total_price in centen → lokale valuta
        var total = ((c && c.total_price)||0) / 100;
        render(total);
      })
      .catch(function(){ /* noop */ });
  }

  document.addEventListener('DOMContentLoaded',  refresh);
  document.addEventListener('cart:updated',      refresh);
  document.addEventListener('ajaxProduct:added', refresh);
  document.addEventListener('ajaxCart:cartUpdate', refresh);
  refresh(); setTimeout(refresh, 80);
})();